import { ModalController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the SearchEmployeeProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class SearchEmployeeProvider {


	constructor(public http: Http, public modalCtrl: ModalController) {
		console.log('Hello SearchEmployeeProvider Provider');
	}

	/**
     * method search multi employee. arrDatas<empId: string, fullName: string, photo:string, posNameEn: string
	 * ,select: boolean, userId:number, empNo:string,[...params]>
     */
	searchMultiEmployee(arrDatas: Array<any>): Promise<any> {
		return new Promise((resolve, reject) => {
			let searchEmp = this.modalCtrl.create('SearchEmpScheduling', arrDatas);
			searchEmp.onDidDismiss(data => {
				if (data != undefined) {
					console.log(data);
					resolve(data);
				} else {
					reject(new Error("No Employee Found"));
				}
			});
			searchEmp.present();
		});
	}

	searchEmployeeElearning(arrDatas: Array<any>, classCode: String): Promise<any> {
		return new Promise((resolve, reject) => {
			let searchEmp = this.modalCtrl.create('SearchEmployeeElrPage', { arrDatas, classCode });
			searchEmp.onDidDismiss(data => {
				if (data != undefined) {
					console.log(data);
					resolve(data);
				} else {
					reject(new Error("No Employee Found"));
				}
			});
			searchEmp.present();
		});
	}

	/**
     * method search one employee. DATATYPE:
	 * LEAVE, ATTCORR, OVT, ATTLIST, REQFORSFGO      
	 */
	searchOneEmployee(dataType: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let searchEmp = this.modalCtrl.create('RequestForLeave', { 'datastype': dataType });
			searchEmp.onDidDismiss(data => {
				if (data != undefined) {
					console.log(data);
					resolve(data);
				} else {
					reject(new Error("No Employee Found"));
				}
			});
			searchEmp.present();
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/search-employee/search-employee.ts